var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconGift = function SvgIconGift(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "evenodd",
    d: "M12.564.15c-.483-.286-1.087-.15-1.45.304L8.94 3.653 6.886.454C6.523 0 5.919-.136 5.436.15c-.483.286-.604.885-.362 1.34l1.691 2.487H1.933C.846 3.976 0 4.873 0 5.979v2.002c0 .743.362 1.39.966 1.735v7.279A3 3 0 0 0 3.986 20h10.027a3 3 0 0 0 3.02-3.005V9.716c.605-.346.967-.992.967-1.735V5.98c0-1.106-.846-2.003-1.933-2.003h-4.832l1.691-2.487c.242-.454.121-1.054-.362-1.34M1.933 7.98h6.04V5.98h-6.04zm8.094-2.002v2.002h6.04V5.98h-6.04M7.973 9.985H3.02v7.01c0 .553.363 1.001.967 1.001h3.986zm2.054 8.011V9.985h4.953v7.01c0 .553-.363 1.001-.967 1.001z"
  })));
};
export default SvgIconGift;